import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Layout from "../layout/Layout";
import { formatUserInfo } from "../config/userInfo.config";
import GTMRouteListener from "../utils/common/gtmRouteListener";

function IndexLayout(props: any) {
  const [checking, setChecking] = useState(true);
  const token = localStorage.getItem("authToken");
  const storedData = localStorage.getItem("userInfo");
  const userInfo = storedData ? storedData : "";

  useEffect(() => {
    if (token) {
      const setCustomerInfo = async () => {
        const customerInfo = await formatUserInfo(userInfo);
        localStorage.setItem("customerInfo", JSON.stringify(customerInfo));
        setChecking(false);
      };
      setCustomerInfo();
    } else {
      setChecking(false);
    }
  }, [token, userInfo]);

  if (checking) return null; // or a spinner

  if (!token) {
    const redirectUrl = process.env.REACT_APP_LKQPORTAL_URL || "/";
    window.location.replace(redirectUrl);
    return null;
  }

  return (
    <Layout>
      <GTMRouteListener />
      <Outlet />
    </Layout>
  );
}

export default IndexLayout;
